import { createSelector } from 'reselect'
import { AppGlobalState, Progress } from '../../types'
import { Report } from './types'
import { EntityMetadata } from 'modules/domain/types'

const dict = (state: AppGlobalState) => state.report.items
const ids = (state: AppGlobalState) => state.report.ids
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const item = (state: AppGlobalState, id: string): Report | undefined => state.report.items[id]
const meta = (state: AppGlobalState, id: string): EntityMetadata<Report> =>
  state.report.meta[id] || {
    fetchError: null,
    fetchProgress: Progress.IDLE,
    id,
    removeError: null,
    removeProgress: Progress.IDLE,
    updateError: null,
    updateProgress: Progress.IDLE,
  }
const itemFetchProgress = (state: AppGlobalState) => state.report.itemFetchProgress
const listFetchProgress = (state: AppGlobalState) => state.report.listFetchProgress
const listFetchError = (state: AppGlobalState) => state.report.listFetchError
const listFetchNextProgress = (state: AppGlobalState) => state.report.listFetchNextProgress
const listFetchNextError = (state: AppGlobalState) => state.report.listFetchNextError
const list = createSelector(dict, ids, listFetchProgress, (dict, ids, progress) => {
  if (progress === Progress.WORK) {
    return []
  }
  const result: Report[] = []
  for (const id of ids) {
    result.push(dict[id])
  }
  return result
})

const filter = (state: AppGlobalState) => state.report.filter
const sorting = (state: AppGlobalState) => state.report.sorting
const page = (state: AppGlobalState) => state.report.page
const total = (state: AppGlobalState) => state.report.total
const updateProgress = (state: AppGlobalState) => state.report.updateProgress
const removeProgress = (state: AppGlobalState) => state.report.removeProgress
const addProgress = (state: AppGlobalState) => state.report.addProgress
const hasNext = (state: AppGlobalState) => state.report.total > state.report.ids.length
const pageSize = (state: AppGlobalState) => state.report.pageSize
const pages = (state: AppGlobalState) => Math.ceil(state.report.total / state.report.pageSize)

const ReportSelectors = {
  filter,
  sorting,
  page,
  total,
  updateProgress,
  removeProgress,
  addProgress,
  item,
  meta,
  itemFetchProgress,
  listFetchProgress,
  listFetchError,
  list,
  dict,
  ids,
  hasNext,
  pageSize,
  listFetchNextProgress,
  listFetchNextError,
  pages,
}

export default ReportSelectors
